import { 
  formatDateID, formatDateTimeID, formatMonthFullID 
} from '@/filters/date.filter';
import { 
  formatCurrencyIDR 
} from '@/filters/currency.filter';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import applicationModule from '@/store/modules/application.module';

Vue.config.productionTip = false;

applicationModule.bootstrap().then(() => {
  Vue.filter('formatDateID', formatDateID);
  Vue.filter('formatDateTimeID', formatDateTimeID);
  Vue.filter('formatCurrencyIDR', formatCurrencyIDR);
  Vue.filter('formatMonthFullID', formatMonthFullID);
  const vueapp = new Vue({router, store, vuetify, render: h => h(App)});
  vueapp.$mount('#app');
});